module.exports = __webpack_public_path__ + "04_long_grey.bf906af0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/04_long_grey.png
// module id = EomH
// module chunks = 0